<template>
  <!-- 活动管理 -->
  <div class="activityListbox">
    <top-title name="风控管理" style="margin: 20px 20px 0 0px; min-width: 1100px"></top-title>
    <div class="activity_title">
      <div class="card-point">
        <div class="card-rule"></div>
        <div class="card-connet">
          <p>根据阿里平台风控体系，有效识别薅羊毛、刷单、恶意秒杀、恶意抢红包等行为的风险用户防止商家活动权益被风险帐号非正常获取</p>
          <!-- <p>1、为避免因奖品发完活动提前结束引起客诉，请仔细核对当前活动内容与活动规则设置，明确活动成本预算</p>
          <p>2、为避免修改成团条件导致客诉，活动创建后成团条件将不可修改，请在创建时仔细核对</p>
          <p>3、活动期间每个用户，同一优惠最多获得一次</p> -->
        </div>
      </div>
      <div>反作弊检测：<el-switch v-model="openStatus" @change="handleChange" :active-value="1" :inactive-value="0"></el-switch></div>
      <div>
        <p style="margin: 10px 0;">
          1.直接活动参与限制:
          <el-select v-model="participationRiskLevel" @change="handleChange" style="width: 120px;" placeholder="请选择">
            <el-option label="高风险" :value="0"></el-option>
            <el-option label="中风险" :value="1"></el-option>
            <el-option label="低风险" :value="4"></el-option>
          </el-select>
          以上账号不可以参与直接活动(如签到、抽奖等活动)
        </p>
        <p style="margin-bottom: 20px;">
          2.被邀请人限制分险等级为
          <el-select v-model="inviteeParticipationRiskLevel" @change="handleChange" style="width: 120px;" placeholder="请选择">
            <el-option label="高风险" :value="0"></el-option>
            <el-option label="中风险" :value="1"></el-option>
            <el-option label="低风险" :value="4"></el-option>
          </el-select>
          以上账号限制参与被邀请活动（如邀请打榜的被邀请人)
        </p>
      </div>
      <div class="card-point">
        <div class="card-rule"></div>
        <div class="card-connet">
          <p>说明</p>
          <p>1、阿里平台将账号风险分为了低、中、高三个等级，请根据活动酌情设置</p>
          <p>2、被限制的用户将会在页面提示:亲，你的账号暂无法参与活动，你可以联系店铺客服咨询哦</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topTitle from "@/components/top-title";
import { preventCheat, savePreventCheat } from "@/api/liveCard/liveCard";
export default {
  components: {
    topTitle,
  },
  data() {
    return {
      openStatus: 0,
      participationRiskLevel: 0,
      inviteeParticipationRiskLevel: 0,
      id: "",
    };
  },
  created() {
    this.buriedPoint(1, "云起互动", "风控管理", "风控管理");
  },
  mounted() {
    this.getInfo();
  },

  methods: {
    async getInfo() {
      const { data: res } = await preventCheat();
      this.openStatus = res.openStatus;
      this.participationRiskLevel = res.participationRiskLevel;
      this.inviteeParticipationRiskLevel = res.inviteeParticipationRiskLevel;
      this.id = res.id ? res.id : "";
    },
    handleChange() {
      let obj = {
        id: this.id,
        openStatus: this.openStatus,
        participationRiskLevel: this.participationRiskLevel,
        inviteeParticipationRiskLevel: this.inviteeParticipationRiskLevel,
      };
      savePreventCheat(obj).then((res) => {
        this.getInfo();
        if (res.code != 1) {
          this.$message.error(res.message);
        } else {
          this.$message.success(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.activityListbox {
  margin: 24px;
  padding: 0px 24px 24px 0px;
  background: #ffffff;
  min-height: calc(100vh - 60px - 48px);
}
.card-point {
  width: 100%;
  background: #f4f7ff;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    // width: 60px;
    background: url("../../assets/thdImg/pages/waringBule.svg") no-repeat;
    background-size: 20px 20px;
    margin-top: 1px;
    margin-right: 5px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.activity_title {
  padding-left: 24px;
}
</style>
